import React, { useState, useEffect } from 'react'
import { Spinner } from '@telavita-core/react-design-kit'

import { NotificationTypeEnum } from 'services/me/preferences'

import { SelectNotificationTypeBannerState } from './SelectNotificationTypeBannerState'
import { SelectSMSBannerState } from './SelectSMSBannerState'
import { SelectWhatsAppBannerState } from './SelectWhatsAppBannerState'

import { InitialBannerStateProps, InitialBannerStateType } from './types'

import * as S from './styles'

export const InitialBannerState: React.FC<InitialBannerStateProps> = ({ 
  isLoading,
  isSuccess,
  handleCloseBanner, 
  handleUpdatePhoneNotification 
}) => {
  const [bannerState, setBannerState] = useState<InitialBannerStateType>('initial')
  const [selectedType, setSelectedType] = useState<InitialBannerStateType>(null)

  function handleSelectOption(type: NotificationTypeEnum) {
    handleUpdatePhoneNotification(type)
    setSelectedType(type)
  }

  useEffect(() => {
    if (isSuccess) {
      setBannerState(selectedType)
    }
  }, [isSuccess, selectedType])

  return (
    <S.Container>
      {isLoading && (
        <S.Loading>
          <Spinner />
        </S.Loading>
      )}

      {bannerState === 'initial'
        ? <SelectNotificationTypeBannerState 
          handleSelectOption={(type: NotificationTypeEnum) => handleSelectOption(type)} 
        />
        : null
      }

      {bannerState === NotificationTypeEnum.SMS
        ? <SelectSMSBannerState handleCloseBanner={handleCloseBanner} />
        : null
      }

      {bannerState === NotificationTypeEnum.WHATSAPP
        ? <SelectWhatsAppBannerState handleCloseBanner={handleCloseBanner} />
        : null
      }
    </S.Container>
  )
}